import React, { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import SearchCriteria from "../../Utils/SearchCriteria";
// import SearchResults from '../../Utils/SearchResults';
import { Container, Alert } from "reactstrap";
import { connect, useDispatch } from "react-redux";
import errors from "../../Constants/errors.json";
import ViewUserDetails from "./ViewForm";
import ViewInternalAppUserDetails from "./ViewFormInternalApp";
import Mapping from "../../Utils/Mapping";
import {
  getUserDetails,
  errorWhileFetch,
  setUserList,
} from "../../../actions/users";
import { Loading } from "../../../loader/Loading";
import InfiniteScrollTable from "../../Common/InfiniteScrollCognito";
import { enAPI } from "../../../config";

const ViewSearch = (props) => {
  const dispatch = useDispatch();

  //   const clearError = () => {
  //     dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  //   };

  //   const clearUsersList = () => {
  //     dispatch({ type: "USERS_LIST", data: { usersList: undefined } });
  //   };
  const getUserDetailsMethod = (username) => dispatch(getUserDetails(username));
  const errorWhileFetchMethod = (err) => dispatch(errorWhileFetch(err));
  const setUserListMethod = (...props) => dispatch(setUserList(...props));

  const [state, setState] = useState({
    modal: false,
    property: "",
  });

  const setProperty = (value) => {
    let newState = {
      property: value,
    };
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
    toggle();
  };

  const toggle = () => {
    setState({
      modal: !state.modal,
    });
  };

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
    dispatch({ type: "USERS_LIST", data: { usersList: undefined } });
    return () => {
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch({ type: "USERS_LIST", data: { usersList: undefined } });
    };
  }, [dispatch]);

  const {
    isLoading,
    error,
    usersList,
    userDetails,
    internalApp,
    app,
    searchAttributes,
  } = props;

  const cols = [
    {
      label: "UserName",
      dataKey: "email",
      width: "250",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <div
            style={{
              backgroundColor: "none",
              borderColor: "none",
              color: "blue",
              cursor: "pointer",
            }}
            onClick={(e) => {
              setProperty(rowData);
              getUserDetailsMethod(rowData.Username);
            }}
          >
            {rowData.email}
          </div>
        );
      },
    },
    {
      label: "First Name",
      dataKey: "given_name",
      width: "100",
    },
    {
      label: "Last Name",
      dataKey: "family_name",
      width: "100",
    },
    {
      label: "Company",
      dataKey: "custom:company",
      width: "250",
    },
  ];
  return (
    <DocumentTitle title={"Doorkeeper | View User"}>
      <Container style={{ padding: "0% 2%" }}>
        <h5 style={{ marginLeft: "42%" }}>View User</h5>
        {state.modal && !error && userDetails ? (
          !internalApp ? (
            <ViewUserDetails
              modal={state.modal}
              toggle={toggle}
              userDetails={userDetails}
            />
          ) : (
            <ViewInternalAppUserDetails
              modal={state.modal}
              toggle={toggle}
              userDetails={userDetails}
            />
          )
        ) : null}
        <SearchCriteria />
        {isLoading && !error && <Loading />}
        {usersList && usersList.length > 0 && searchAttributes && !error && (
          /*<SearchResults
							columns={columns}
							data={this.props.usersList}
							tableHeight={'50vh'}
						/>*/
          <InfiniteScrollTable
            columnData={cols}
            data={usersList}
            gridClassName={"gridClass"}
            rowHeight={45}
            page={"viewSearch"}
            url={`${enAPI}${app}/searchusers`}
            lastKey={props.lastKey}
            authToken={props.authToken}
            searchAttributes={searchAttributes}
            errorWhileFetch={errorWhileFetchMethod}
            setUserList={setUserListMethod}
          />
        )}
        {!error && usersList && usersList.length === 0 && !isLoading && (
          <Alert color="info" style={{ textAlign: "center" }}>
            <h6>No records found.</h6>
          </Alert>
        )}
        {error && (
          <Alert color="danger" style={{ textAlign: "center" }}>
            <h5>
              <Mapping dictionary={errors} word={error.errorPath} />
            </h5>
          </Alert>
        )}
      </Container>
    </DocumentTitle>
  );
};

const mapStateToProps = (state) => {
  return {
    usersList: state.users.usersList,
    isLoading: state.fetch.isLoading,
    error: state.error.error_obj,
    userDetails: state.users.userDetails,
    internalApp: state.pool.internalApp,
    app: state.pool.userPool,
    authToken: state.auth.token,
    searchAttributes: state.users.searchAttributes,
    lastKey: state.users.lastKey,
  };
};

export default connect(mapStateToProps)(ViewSearch);
